export default function Features() {
  const features = [
    {
      icon: 'ri-route-line',
      title: 'AI Route Optimisation',
      description: 'Smart algorithms match you with drivers and passengers on the same daily route, maximising efficiency and savings.',
    },
    {
      icon: 'ri-user-shared-2-line',
      title: 'Smart Driver & Passenger Matching',
      description: 'Intelligent pairing connects commuters heading to the same destination every day, building reliable carpool groups.',
    },
    {
      icon: 'ri-women-line',
      title: 'Women Driver for Women Passengers',
      description: 'Exclusive women-only carpooling option for enhanced safety and comfort during daily commutes.',
    },
    {
      icon: 'ri-calendar-schedule-line',
      title: 'Flexible Scheduling',
      description: 'Set your carpool on a daily, weekly, or monthly basis to match your commute pattern and lifestyle.',
    },
    {
      icon: 'ri-map-pin-time-line',
      title: 'Real-time Tracking',
      description: 'Live GPS tracking with accurate ETAs, share your trip status with family for peace of mind.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Safety First',
      description: 'SOS button, trip sharing, verified drivers, and 24/7 safety monitoring for every journey.',
    },
  ];

  return (
    <section id="ai-features" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center bg-teal-100 rounded-full px-4 py-2 mb-4">
            <i className="ri-sparkling-line text-teal-600 mr-2 w-4 h-4 flex items-center justify-center"></i>
            <span className="text-xs font-medium text-teal-700" style={{ fontFamily: "'Inter', sans-serif" }}>
              Enhanced AI Technology
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Smart Carpooling Features
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto" style={{ fontFamily: "'Inter', sans-serif" }}>
            Daily carpooling made easy with AI-powered matching for commuters sharing the same destination.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-lg p-8 shadow-sm hover:shadow-md transition-all hover:-translate-y-1 border border-gray-100"
            >
              <div className="w-12 h-12 bg-teal-50 rounded-lg flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-2xl text-teal-600 w-6 h-6 flex items-center justify-center`}></i>
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-2" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                {feature.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
